<template>
  <v-col class="pa-0">
    <v-row class="py-3">
      <v-col class="d-flex align-center" cols="12" md="">
        <div class="text-title title px-0">
          {{ $t("mainStore.aboutStore.generealGraph.title") }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0" cols="12" md="6">
        <div class="py-0">
          <!-- <v-select v-model="selectedOption" :items="options"
            :label="$t('mainStore.aboutStore.generealGraph.selectLabel')"></v-select> -->
        </div>
      </v-col>  
      <v-col cols="12" md="12">
        <div class="d-flex flex-wrap">
          <div v-for="(item, idx) in forms" :key="idx">
            <v-card width="350" class="px-4 mb-2 mr-3" elevation="0" outlined>
              <div class="d-flex align-center justify-space-between">
                <v-card-title>{{
                  `${$t("mainStore.aboutStore.generealGraph.card")} ${idx + 1}`
                }}</v-card-title>
                <v-icon @click="forms.splice(idx, 1)"
                  >mdi-trash-can-outline</v-icon
                >
              </div>
              <v-card-text>
                <v-text-field
                  class="font-weight-bold"
                  v-model="item.title"
                  :label="`${$t(
                    'mainStore.aboutStore.generealGraph.cardTitle'
                  )} ${idx + 1}`"
                ></v-text-field>
                <v-textarea
                  v-model="item.subtitle"
                  :label="`${$t(
                    'mainStore.aboutStore.generealGraph.cardSubtitle'
                  )} ${idx + 1}`"
                ></v-textarea>
              </v-card-text>
            </v-card>
          </div>
          <v-card
            v-if="forms.length <= 2"
            @click="addCard"
            width="350"
            elevation="0"
            outlined
            class="grey lighten-3 d-flex px-4 mb-2 mr-3"
            style="place-content: center"
          >
            <v-icon class="black--text" x-large>mdi-plus-circle-outline</v-icon>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      formSkell: {
        title: null,
        subtitle: null,
      },
      forms: [],
      cloneSnap: [],
      selectedOption: null,
      titles: [],
      subtitles: [],
      cardsLimits: 3, // limita a quantidade de cards
    };
  },

  props: {
    snap: {
      type: Array,
      default: undefined || null,
    },
  },
  computed: {
    ...mapState("groupStores", ["selectedStore"]),

    options() {
      return [
        this.$t("mainStore.aboutStore.generealGraph.singularCard"),
        this.$t("mainStore.aboutStore.generealGraph.twoCards"),
        this.$t("mainStore.aboutStore.generealGraph.ThreeCards"),
      ];
    },

    selectedOptionIndex() {
      return this.options.indexOf(this.selectedOption); // Retonr o indice do elementa passado por parametro encontrado e adiciona mais um
    },
  },

  mounted() {
    if (this.snap && this.snap.length) {
      this.cloneSnap = JSON.parse(JSON.stringify(this.snap));
      this.forms = this.cloneSnap;
    } else {
    }
  },

  watch: {
    forms: {
      deep: true,
      handler(nv) {
        console.log("mudou");
        this.save();
      },
    },

    selectedStore: {
      deep: true,
      haldler() {
        this.form = this.snap;
      },
    },
  },

  methods: {
    addCard() {
      if (this.forms.length < this.cardsLimits) {
        this.forms.push(JSON.parse(JSON.stringify(this.formSkell)));
      } else {
      }
    },

    save() {
      const snap = JSON.parse(JSON.stringify(this.forms));
      //const form = []
      // for(let i=0; i < this.selectedOptionIndex; i++){
      //   form.push(snap[i])
      // }
      // let fiterForm = this.form.filter(item => this.form.indexOf(item) < this.selectedOptionIndex)
      // console.log('formBeforeSave', fiterForm)
      this.$emit("update-store", snap);
    },
  },
};
</script>
